import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden });
